import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { GlobalSearchPath } from '../../constants/global-search-path';
import { ObjectNames } from "../../constants/object.names";
import { CONTACT_ASSOCIATION_ID } from '../../constants/typeId';
import { OpportunityService } from 'src/app/opportunities/opportunity.service';
import { MLAINS } from '../../models/ml.ai.model';
import { environment } from 'src/environments/environment';
interface AnchorData {
    name: string;
    extension: string;
    downloadLink: string;
}
@Component({
    selector: 'app-shared-detail-block',
    templateUrl: './shared-detail-block.component.html',
    styleUrls: ['./shared-detail-block.component.scss'],
})

export class SharedDetailBlockComponent implements OnChanges {

    @Input() moduleName = '';
    @Input() column: any[] = [];
    @Input() data;
    @Input() qualifiedId = 0;
    @Input() linkFields = ['contactname', 'businessName', 'fullName', 'name', 'accountName', 'caseNo', 'assoName', 'templateName'];
    @Output() viewDetails = new EventEmitter<any>();
    @Output() openLocationDialog = new EventEmitter<number>();

    column1: any[] = [];
    column2: any[] = [];
    column1Address;
    column2Address;

    popUpColumns: any[] = [];
    dataId;
    moduleType = '';
    displayDetailPopup = false;
    popupHeader = '';
    paths = GlobalSearchPath;
    objectNames = ObjectNames;
    phoneFields: string[] = ['contactphonework', 'contactphonemobile', 'contactphonehome', 'contactphonecp1', 'contactphonecp2', 'assistantPhone'];


    displayFilePreview: boolean = false;
    currentFile: any;

    associationTypeId: number = 0;

    scoreName: string;
    scoreToolTip: string = '';
    gradeToolTip: string = '';
    opportunityMLAIScore: MLAINS.OpportunityMLAIScore;
    assestBaseUrl: string = environment.assestsBasePath;


    constructor(private opportunityService: OpportunityService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.column?.currentValue) {
            this.column = changes.column?.currentValue;
            if (this.moduleName != 'Product') {
                this.column.forEach(x => {
                    x['ischecked'] = (typeof x['show'] != "undefined") ? x['show'] : (typeof x['ischecked'] != "undefined") ? x['ischecked'] : false;
                    x['labelname'] = (typeof x['header'] != "undefined") ? x['header'] : (typeof x['labelname'] != "undefined") ? x['labelname'] : '';
                });
            } else if (this.moduleName == 'Product' || this.moduleName == 'Vendor' || this.moduleName == 'Location') {
                this.column.forEach(x => {
                    x.ischecked = x.checked;
                });
            }
            let checkedColumn = this.column.filter(x => x.ischecked);
            if (checkedColumn.length > 6) {
                this.column1 = checkedColumn.slice(0, 6);
                this.column2 = checkedColumn.slice(5 + 1, 12);
            } else {
                this.column1 = checkedColumn;
                this.column2 = [];
            }

            this.column1Address = this.column1.find(x => x.field == 'address');
            this.column2Address = this.column2.find(x => x.field == 'address');
        }

        if (changes.data?.currentValue) {
            this.data = changes.data?.currentValue;

            if (this.data?.attachments != null) {
                this.data.attachmentLinks = this.processAttachmentData(this.data?.attachments);
            }

            if (this.moduleName == this.objectNames.CASES) {
                if ((this.data.caseAssociationName === 'Lead' || this.data.caseAssociationName === 'Account')) {
                    this.linkFields = ['contactname', 'businessName', 'fullName', 'name', 'accountName', 'ticketNo', 'associationName'];
                } else {
                    this.linkFields = ['contactname', 'businessName', 'fullName', 'name', 'accountName', 'ticketNo'];
                }
            }

            if (this.moduleName == this.objectNames.CONTACT) {
                if (this.data.contactAssociationId === CONTACT_ASSOCIATION_ID.ACCOUNT || this.data.contactAssociationId === CONTACT_ASSOCIATION_ID.LEAD) {
                    this.linkFields = ['contactname', 'businessName', 'fullName', 'name', 'accountName', 'caseNo', 'assoName'];
                } else {
                    this.linkFields = ['contactname', 'fullName', 'name', 'accountName', 'caseNo', 'assoName'];
                }
            }

            if (this.moduleName == this.objectNames.TERRITORY) {
                this.linkFields = ['name'];
            }

            if (this.moduleName == this.objectNames.WORKFLOW) {
                this.linkFields = [];
            }

            if (this.column?.find(x => x.ischecked && x.field == 'address')) {
                this.data['cityStateCountry'] = (this.data['city'] ? this.data['city'] + ', ' : '')
                    + (this.data['state'] ? this.data['state'] + ', ' : '')
                    + (this.data['country'] ? this.data['country'] + ', ' : '')
                    + (this.data['zipcode'] ? this.data['zipcode'] : '');
            }
        }

        if (this.moduleName == this.objectNames.OPPORTUNITY) {
            this.scoreName = "Opportunity Score";
            this.scoreToolTip = MLAINS.LeadsMLAIScoreConstantText.opportunityScoringInfo;
            this.gradeToolTip = MLAINS.LeadsMLAIScoreConstantText.opportunityGradeInfo;
            this.getOpportunityMLAIScore();
        }

        if (this.moduleName === this.objectNames.PRODUCT) {
            const numericFields = [
                'QOH', 'availabel', 'onorder', 'backorder',
                'onso', 'committed', 'availtopick', 'onpo',
                'returnqty', 'shipqty'
            ];

            for (let col of this.column) {
                const field = col.field;
                if (numericFields.includes(field)) {
                    const value = this.data[field];
                    if (typeof value === 'string') {
                        this.data[field] = value.replace(/,/g, '');
                    }
                }
            }
        }
    }

    detailsView(rowData: any) {
        this.openLocationDialog.emit(rowData.warehouseId);
    }

    setDetailsPopupData(field) {

        this.popUpColumns = [];
        if (this.moduleName !== 'Vendor' && this.linkFields.includes(field)) {
            this.displayDetailPopup = true;
        }

        if (this.moduleName == this.objectNames.CASES) {
            if (field === 'ticketNo') {
                this.moduleType = this.objectNames.CASES;
                this.popupHeader = 'Case Details';
                this.dataId = this.data.id;
                this.popUpColumns = this.column;
            }
            //  else if (field === 'contactName') {
            //     this.moduleType = this.objectNames.CONTACT;
            //     this.popupHeader = 'Contact Details';
            //     this.dataId = this.data.contactId;
            // }
            else if (field === 'associationName') {
                if (this.data.caseAssociationName === 'Lead') {
                    this.moduleType = this.objectNames.LEADS;
                    this.popupHeader = 'Lead Details';
                    this.dataId = this.data.associationNameId;
                } else if (this.data.caseAssociationName === 'Account') {
                    this.moduleType = this.objectNames.ACCOUNT;
                    this.popupHeader = 'Account Details';
                    this.dataId = this.data.associationNameId;
                }
            }
        } else if (this.moduleName == this.objectNames.LEADS) {
            if (field === 'contactname') {
                this.moduleType = this.objectNames.CONTACT;
                this.popupHeader = 'Contact Details';
                let contact = this.data?.leadContacts && this.data?.leadContacts.length > 0 ?
                    this.data?.leadContacts.find(x => x.contact && x.contact.isPrimaryContact) : 0
                this.dataId = contact ? contact?.contactId : 0;
                this.associationTypeId = contact?.contact?.contactAssociationTypeId || this.data?.contact?.contactAssociationId;
            } else if (field === 'businessName') {
                this.moduleType = this.objectNames.LEADS;
                this.popupHeader = 'Lead Details';
                this.dataId = this.data.id;
                this.popUpColumns = this.column;
            }
        } else if (this.moduleName == this.objectNames.CONTACT) {
            if (field === 'fullName') {
                this.moduleType = this.objectNames.CONTACT;
                this.popupHeader = 'Contact Details';
                this.dataId = this.data.id;
                this.associationTypeId = this.data?.contactAssociationTypeId || this.data?.contactAssociationId;
                this.popUpColumns = this.column;
            } else if (field === 'businessName') {
                if (this.data.contactAssociationId === CONTACT_ASSOCIATION_ID.ACCOUNT) {
                    this.moduleType = this.objectNames.ACCOUNT;
                    this.popupHeader = 'Account Details';
                    this.dataId = this.data.associationId;
                } else if (this.data.contactAssociationId === CONTACT_ASSOCIATION_ID.LEAD) {
                    this.moduleType = this.objectNames.LEADS;
                    this.popupHeader = 'Lead Details';
                    this.dataId = this.data.associationId;
                }
            }
        } else if (this.moduleName == this.objectNames.ACCOUNT) {
            if (field === 'businessName') {
                this.moduleType = this.objectNames.ACCOUNT;
                this.popupHeader = 'Account Details';
                this.dataId = this.data.id;
                this.popUpColumns = this.column;
            } else if (field === 'contactname') {
                this.moduleType = this.objectNames.CONTACT;
                this.popupHeader = 'Contact Details';
                let contact = this.data?.accountContacts && this.data?.accountContacts.length > 0 ?
                    this.data?.accountContacts.find(x => x.contact && x.contact.isPrimaryContact) : 0
                this.dataId = contact ? contact?.contactId : 0;
                this.associationTypeId = contact?.contact?.contactAssociationTypeId || this.data?.contact?.contactAssociationId;
            }
        } else if (this.moduleName == this.objectNames.OPPORTUNITY) {
            if (field === 'name') {
                this.moduleType = this.objectNames.OPPORTUNITY;
                this.popupHeader = 'Opportunity Details';
                this.dataId = this.data.id;
                this.popUpColumns = this.column;
            } else if (field === 'accountName') {
                this.moduleType = this.objectNames.ACCOUNT;
                this.popupHeader = 'Account Details';
                this.dataId = this.data.accountId;
            }
        } else if (this.moduleName == this.objectNames.TERRITORY) {
            if (field === 'name') {
                this.displayDetailPopup = false;
                this.showDetails();
            }
        } else if (this.moduleName == this.objectNames.ROUTE) {
            if (field === 'name') {
                this.displayDetailPopup = false;
                this.showDetails();
            }
        } else if (this.moduleName == this.objectNames.SavedSearch) {
            if (field === 'name') {
                this.displayDetailPopup = false;
                this.showDetails();
            }
        } else if (this.moduleName == this.objectNames.PRODUCT) {
            if (field === 'QOH' || field == 'availabel' || field == 'onorder' || field == 'backorder' || field == 'onso'
                || field == 'committed' || field == 'availtopick' || field == 'onpo' || field == 'returnqty' || field == 'shipqty') {
                this.showDetails(field);
            }
        } else if (this.moduleName == 'Campaign') {
            if (field === 'name') {
                this.displayDetailPopup = false;
                this.showDetails(field);
            } else if (field === 'templateName') {
                this.displayDetailPopup = false;
                this.showDetails(field);
            }
        }
    }

    processAttachmentData(attachments: Array<any>): AnchorData[] {
        let allLinks: AnchorData[] = [];

        for (let i = 0; i < attachments.length; i++) {
            allLinks.push({
                name: attachments[i]?.name || '',
                extension: attachments[i]?.extension || '',
                downloadLink: attachments[i]?.downloadLink || ''
            });
        }

        return allLinks;
    }

    openFilePreview(file: any): void {
        this.displayFilePreview = true;
        this.currentFile = file;
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }

    showDetails(field?) {
        this.viewDetails.emit(field);
    }


    closeDialog() {
        this.displayDetailPopup = false;
    }

    getOpportunityMLAIScore(): void {
        this.opportunityService.getOpportunityMLAIScore(this.data.id).subscribe((res: MLAINS.OpportunityMLAIScore) => {
            this.opportunityMLAIScore = res;
            if (this.opportunityMLAIScore?.lastUpdatedDate) {
                // this.opportunityMLAIScore.lastUpdatedDate = this.app._showDateTimeWithZone(new Date(this.opportunityMLAIScore?.lastUpdatedDate));
                this.opportunityMLAIScore.lastUpdatedDate = new Date(this.opportunityMLAIScore?.lastUpdatedDate);
            }
            if (this.opportunityMLAIScore) {
                if (this.opportunityMLAIScore?.differenceFromLastScore > 0) {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.improving;
                    this.opportunityMLAIScore.differenceFromLastScoreText = `+${this.opportunityMLAIScore?.differenceFromLastScore}`;
                }
                else if (this.opportunityMLAIScore?.differenceFromLastScore < 0) {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.down;
                    this.opportunityMLAIScore.differenceFromLastScoreText = `${this.opportunityMLAIScore?.differenceFromLastScore}`;
                }
                else {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.steady;
                    this.opportunityMLAIScore.differenceFromLastScoreText = ``;
                }
            }
        });
    }
}
